module.exports = __webpack_public_path__ + "img/signal-strong.799030f4.svg";